import domReady from './dom-ready.js';
import lazy from './lazy.js';
export { domReady, lazy };
//# sourceMappingURL=index.js.map